const FirebaseConfig = {
  apiKey: "AIzaSyC97oaeqlIuDG3TJg_nZTk3Y-RY5pfHpZw",
  authDomain: "express-main-ab81d.firebaseapp.com",
  projectId: "express-main-ab81d",
  storageBucket: "express-main-ab81d.appspot.com",
  messagingSenderId: "900087320221",
  appId: "1:900087320221:web:b1848725e3629e737cce74"
};

export default FirebaseConfig

{/*
******* Express keys *************
 apiKey: "AIzaSyC97oaeqlIuDG3TJg_nZTk3Y-RY5pfHpZw",
  authDomain: "express-main-ab81d.firebaseapp.com",
  projectId: "express-main-ab81d",
  storageBucket: "express-main-ab81d.appspot.com",
  messagingSenderId: "900087320221",
  appId: "1:900087320221:web:b1848725e3629e737cce74" */}


  {/*
  *********   GURUGHAR KEYS (REACTBASE)   *************
  apiKey: "AIzaSyDJpfLgctgUQXPS9P_fNXVoK3Ywq-pT4_w",
  authDomain: "react-base-backend.firebaseapp.com",
  databaseURL: "https://react-base-backend-default-rtdb.firebaseio.com",
  projectId: "react-base-backend",
  storageBucket: "react-base-backend.appspot.com",
  messagingSenderId: "730847772912",
  appId: "1:730847772912:web:5630e0389dc67c1ce40235"
*/}